import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./footer.css";

import { Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Link } from "react-router-dom";

import logo from "../../assets/images/logo.png";
import map from "../../assets/images/iconMap.png";
import phone from "../../assets/images/iconPhone.png";
import iconFacebook from "../../assets/images/iconFacebookWhite.png";
import iconInsta from "../../assets/images/iconInstaWhite.png";
import iconGoogle from "../../assets/images/iconGoogleWhite.png";
import iconTiktok from "../../assets/images/iconTiktokWhite.png";
import iconFacebookMobile from "../../assets/images/iconFacebook.png";
import iconInstaMobile from "../../assets/images/iconInstagram.png";
import iconGoogleMobile from "../../assets/images/iconGoogle.png";
import iconTiktokMobile from "../../assets/images/iconTiktok.png";

import footer from "../../assets/images/footer.png";
import footerMobile from "../../assets/images/footer_light.png";

const quick__links = [
  {
    path: "/ho-tro",
    display: "customer_support",
  },
  {
    path: "/chinh-sach-doi-tra",
    display: "return_policy",
  },
  {
    path: "/chinh-sach-bao-mat",
    display: "privacy_policy",
  },
  // {
  //   path: "/dieu-khoan-dich-vu",
  //   display: "terms_of_service",
  // },
];
const quick__links2 = [
  {
    path: "/trang-chu",
    display: "home",
  },
  {
    path: "/gioi-thieu",
    display: "about",
  },
  {
    path: "/san-pham/henk",
    display: "henk",
  },
  {
    path: "/san-pham/mark-and-milk",
    display: "mark_and_milk",
  },
  {
    path: "/san-pham/ganafarm",
    display: "ganafarm",
  },
  {
    path: "/san-pham/mekong-cocoa",
    display: "mekong_cocoa",
  },
  {
    path: "/lien-he",
    display: "contact",
  },
];

export const Footer = () => {
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1023);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 1023);
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { t, i18n } = useTranslation(); // Thêm useTranslation

  return (
    <footer className="footer">
      <img src={footer} alt="" className="img-footer" />
      <div className="importantStyles container" style={{ paddingTop: "50px" }}>
        {isMobile ? (
          // Layout cho mobile
          <div>
            <div className="content-footer">
              <img
                src={logo}
                alt=""
                style={{ marginBottom: "24px", width: "40%" }}
              />
              <div className="logo">
                <p
                  className="footer-text-about"
                  style={{
                    marginBottom: "8px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  {t("about_us")}
                </p>
                <p>{t("about_company")}</p>
                <div className="address">
                  <img src={map} alt="" className="map" />
                  <p>{t("address")}</p>
                </div>
                <div className="phone">
                  <img src={phone} alt="" className="map" />
                  <div>
                    <p>online@markandmilk.com</p>
                    <p>+(84) 941 604 103</p>
                  </div>
                </div>
              </div>
              <div className="footer__quick-link">
                <ListGroup className="footer__quick-links">
                  <ListGroupItem className="border-0 d-flex align-items-center gap-3">
                    <p className="mb-0" style={{ fontWeight: "bold" }}>
                      {t("footer_contact_us")}
                    </p>
                  </ListGroupItem>
                  <ListGroupItem className="border-0 d-flex align-items-center gap-3">
                    <div className="d-flex list-group-icon">
                      <Link to={`/lien-he`}>
                        <img src={iconGoogleMobile} alt="Google" />
                      </Link>
                      <Link to={`/lien-he`}>
                        <img src={iconTiktokMobile} alt="TikTok" />
                      </Link>
                      <Link to={`/lien-he`}>
                        <img src={iconInstaMobile} alt="Instagram" />
                      </Link>
                      <Link
                        to={`https://www.facebook.com/mekongzonechocolate`}
                        target="_blank"
                      >
                        <img src={iconFacebookMobile} alt="Facebook" />
                      </Link>
                    </div>
                  </ListGroupItem>
                </ListGroup>
              </div>
              <div />
            </div>
            <img src={footerMobile} alt="" className="footer-img-mobile" />
          </div>
        ) : isTablet ? (
          // Layout cho tablet
          <div>
            <div className="content-footer">
              <img
                src={logo}
                alt=""
                style={{ marginBottom: "24px", width: "20%" }}
              />
              <div className="logo">
                <div className="footer__info">
                  <div className="footer__contact">
                    <p
                      className="footer-text-about"
                      style={{
                        marginBottom: "8px",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      {t("about_us")}
                    </p>
                    <p>{t("about_company")}</p>
                    <div className="address">
                      <img src={map} alt="" className="map" />
                      <p>{t("address")}</p>
                    </div>
                    <div className="phone">
                      <img src={phone} alt="" className="map" />
                      <div>
                        <p>online@markandmilk.com</p>
                        <p>+(84) 941 604 103</p>
                      </div>
                    </div>
                  </div>
                  <div className="footer__quick-link">
                    <ListGroup className="footer__quick-links">
                      <ListGroupItem className="border-0 d-flex align-items-center gap-3">
                        <p className="mb-0 footer-text-contact" style={{ fontWeight: "bold" }}>
                          {t("footer_contact_us")}
                        </p>
                      </ListGroupItem>
                      <ListGroupItem className="border-0 d-flex align-items-center gap-3">
                        <div className="d-flex list-group-icon">
                          <Link to={`/lien-he`}>
                            <img src={iconGoogleMobile} alt="Google" />
                          </Link>
                          <Link to={`/lien-he`}>
                            <img src={iconTiktokMobile} alt="TikTok" />
                          </Link>
                          <Link to={`/lien-he`}>
                            <img src={iconInstaMobile} alt="Instagram" />
                          </Link>
                          <Link
                            to={`https://www.facebook.com/mekongzonechocolate`}
                            target="_blank"
                          >
                            <img src={iconFacebookMobile} alt="Facebook" />
                          </Link>
                        </div>
                      </ListGroupItem>
                    </ListGroup>
                  </div>
                </div>
              </div>

              <div />
            </div>
            <img src={footerMobile} alt="" className="footer-img-mobile" />
          </div>
        ) : (
          // Layout cho desktop
          <Row>
            <Col lg="5" style={{padding:"0"}}>
              <div className="logo">
                <img src={logo} alt="" style={{ marginBottom: "24px" }} />
                <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                  {t("about_us")}
                </p>
                <p>{t("about_company")}</p>
                <div className="address">
                  <img src={map} alt="" className="map" />
                  <p>{t("address")}</p>
                </div>
                <div className="phone">
                  <img src={phone} alt="" className="map" />
                  <div>
                    <p>online@markandmilk.com</p>
                    <p>+(84) 941 604 103</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="3" className="footer__quick-link">
              <ListGroup className="footer__quick-links">
                {quick__links.map((item, index) => (
                  <ListGroupItem key={index} className="ps-0 border-0">
                    <Link to={item.path}>{t(item.display)}</Link>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Col>
            <Col lg="2" className="footer__quick-link">
              <ListGroup className="footer__quick-links">
                {quick__links2.map((item, index) => (
                  <ListGroupItem key={index} className="ps-0 border-0">
                    <Link to={item.path}>{t(item.display)}</Link>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Col>
            <Col lg="2" className="footer__quick-link">
              <ListGroup className="footer__quick-links">
                <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-3">
                  <p className="mb-0">{t("contact_us")}</p>
                </ListGroupItem>
                <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-3">
                  <div className="d-flex gap-2">
                    <Link to={`/lien-he`}>
                      <img src={iconGoogle} alt="Google" />
                    </Link>
                    <Link to={`/lien-he`}>
                      <img src={iconTiktok} alt="TikTok" />
                    </Link>
                    <Link to={`/lien-he`}>
                      <img src={iconInsta} alt="Instagram" />
                    </Link>
                    <Link
                      to={`https://www.facebook.com/mekongzonechocolate`}
                      target="_blank"
                    >
                      <img src={iconFacebook} alt="Facebook" />
                    </Link>
                  </div>
                </ListGroupItem>
              </ListGroup>
            </Col>
          </Row>
        )}
      </div>
    </footer>
  );
};

export default Footer;
